export default "__VITE_ASSET__Fpm7xVZa__"